import { MantineThemeOverride } from '@mantine/core';

export type SkeletonTheme = NonNullable<MantineThemeOverride['components']>['Skeleton'];

export const Skeleton: SkeletonTheme = {
  // todo: define
};
